/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';

const __vue_script__ = {
    name: 'NavEditor',

    components: {
        MetaForm
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        navConfig: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            config: {},
            loading: false,
            fields: null,
            saving: false,
            builder: null,
            ready: false
        };
    },

    computed: {
        title() {
            return this.$te(this.navConfig.editorTitle) ? this.$t(this.navConfig.editorTitle) : this.navConfig.editorTitle;
        }
    },

    async created() {
        this.loadNavConfig();
    },

    methods: {
        async loadNavConfig() {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;

                const registry = await this.$services.settings.getRegistryNav(this.event._id, this.navConfig.editor);

                const fields = [];
                for (const [key, value] of Object.entries(registry.form)) {
                    const field = { ...value };
                    field.field = key;
                    fields.push(field);
                }

                this.builder = registry.builder;
                this.fields = fields;

                this.config = await this.$services.navs.getNavConfig(this.event._id, this.navConfig.navs, {
                    builder: this.builder
                });

            } catch (error) {
                console.error('[NavEditor] Error loading nav config', error);
                this.$services.crashReporting.captureException(error);
                this.flashError();

            } finally {
                this.loading = false;
                this.ready = true;
            }
        },

        async save(data) {
            try {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                await this.$services.navs.saveNav(this.event._id, this.event.node, data, {
                    builder: this.builder,
                    navs: this.navConfig.navs,
                    $services: this.$services
                });

                this.$refs.form.$refs.form.reset();

                this.$notify({
                    group: 'flashes',
                    text: this.$t('general_settings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.loadNavConfig();

            } catch (error) {
                console.error('[NavEditor] Error saving nav config', error);
                this.flashError(error);
            } finally {
                this.saving = false;
            }
        },

        isFormDirty() {
            return get(this.$refs, 'form.$refs.form.flags.dirty', false);
        },

        async validate() {
            await this.$refs.form.validate();
        },

        flashError(error) {
            this.$services.crashReporting.captureException(error);
            this.$notify({
                group: 'flashes',
                title: this.$t('general.error_occurred'),
                text: this.$t('general.try_later'),
                type: 'error',
            });
        }

    }
};


/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-editor"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.ready)?[_c('meta-form',{ref:"form",attrs:{"value":_vm.config,"fields":_vm.fields,"event":_vm.event,"edit":true,"single-panel":true},on:{"valid":_vm.save}}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.saving},on:{"click":_vm.validate}},[_vm._v(_vm._s(_vm.$t('general.save')))])])]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "NavEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__